var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"opacity":0.0}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }